import { Application } from "@hotwired/stimulus"
import RevealController from "@stimulus-components/reveal"
import Sortable from "@stimulus-components/sortable"

const application = Application.start()

application.register('reveal', RevealController)
application.register('sortable', Sortable)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
